import { call, put, select } from "redux-saga/effects";
import { selectUser } from "../../features/auth/authSlice";
import { User } from "../../types/User";
import { Dash } from "../../types/Dash";
import {
  setError as setDashError,
  setStatus as setDashStatus,
} from "../../features/library/librarySlice";
import * as actions from "../actions";
import {
  apiCreateFile,
  apiOpenFile,
} from "../../services/RepoAPI";
import {
  apiGetDash,
  apiUpdateDashFile,
} from "../../services/DashAPI";

/**
 * Creates a repo file and sets its contents using updateDashFile.
 * Ensures the file is associated with a dash (creates one if needed).
 */
export function* createRepoFileWithContent(
  action: ReturnType<typeof actions.createRepoFileWithContent>
) {
  yield put(setDashStatus({ status: "loading", error: undefined }));

  try {
    const userState = (yield select(selectUser)) as User;
    const { repoId, file_name, file_path, codeSet } = action.payload;

    console.log(file_name);

    // Strip any trailing ``` from file_name
    let cleanedFileName = file_name;
    while (cleanedFileName.endsWith("```")) {
      cleanedFileName = cleanedFileName.slice(0, -3);
    }

    // Step 1: Create the file
    const createResponse = yield call(
      apiCreateFile,
      userState.default_organization_id,
      userState.default_workspace_id,
      repoId,
      "/" + cleanedFileName
    );
    
    // Step 1b: Use OpenFile API to get the dashId (since createResponse only returns success: true/false)
    const openResponse = yield call(
      apiOpenFile,
      userState.default_organization_id,
      userState.default_workspace_id,
      repoId,
      "/" + cleanedFileName
    );
    
    const dashId = openResponse.data.dash.id;

    // Step 2: Get the dash without opening it
    const dash: Dash = yield call(
      apiGetDash,
      userState.default_organization_id,
      userState.default_workspace_id,
      dashId
    );

    // Step 3: Verify the dash is associated with the file
    // If not, the dash should already be created and associated by apiCreateFile
    if (!dash.repo_id || !dash.repo_file_name) {
      // The dash should already be associated, but if not, we'll use the dash we got
      // In practice, apiCreateFile should handle this
      console.warn("Dash may not be properly associated with file", dash);
    }

    // Step 4: Refresh the file list
    yield put(actions.fileList({ id: repoId, folder: file_path }));

    // Step 5: (Removed - do not set editing dash)

    // Step 6: Update the file content directly using apiUpdateDashFile
    if (codeSet && dash.id) {
      yield call(
        apiUpdateDashFile,
        userState.default_organization_id,
        userState.default_workspace_id,
        dash.id,
        codeSet
      );
    }

    yield put(setDashStatus({ status: "idle", error: "File saved!" }));
  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}
